import { Tooltip } from '@bancobarigui/barihaus';
import { EditOutlined } from '@ant-design/icons';
import { DisplayRule } from '../../types';
import { getConditionLabel, getActionLabel } from '../utils/displayRuleLabels';

interface DisplayRuleDescriptionProps {
  rule: DisplayRule;
  onClick: () => void;
}

export function DisplayRuleDescription({ rule, onClick }: DisplayRuleDescriptionProps) {
  const conditionLabel = getConditionLabel(rule.condition);
  const actionLabel = getActionLabel(rule.action);

  return (
    <div>
      <div>Regra:</div>
      <div onClick={onClick}>
        <Tooltip title="Clique para editar a regra">
          <span>
            Se resposta {conditionLabel} "{rule.value}", então {actionLabel}
          </span>
          <EditOutlined className="ml-2" />
        </Tooltip>
      </div>
    </div>
  );
}
